<template>
  <el-dialog
      v-el-drag-dialog
      append-to-body
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="打印电阻内盒中性"
      class="materialCodeModal"
      width="500px"
      top="5vh">
    <!--    80*40-->
    <div id="labelSettings">
      <el-form :inline="true" label-width="120px">
        <el-form-item label="TYPE">
          <el-input v-model="printType"/>
        </el-form-item>
        <el-form-item label="DATE">
          <el-input v-model="printDate"/>
        </el-form-item>
        <el-form-item label="PCS">
          <el-input v-model="printPcs"/>
        </el-form-item>
        <el-form-item label="条码">
          <el-input v-model="barCodeText" @input="codeChange"/>
        </el-form-item>
      </el-form>
    </div>
    <el-divider/>
    <div id="labelContent">
      <table style="border: 0;" id="printMaterialBoxLabel2">
        <tr>
          <td style="text-align: center;border:0;" colspan="3">
            <span style="font-size: 20px;font-weight: bold">{{printType}}</span></td>
        </tr>
        <tr>
          <td style="width: 10px;"/>
          <td style="font-size: 20px;">DATE:{{printDate}}</td>
          <td style="font-size: 20px;">PCS:{{printPcs}}</td>
        </tr>
        <tr>
          <td colspan="3" style="text-align: center;">
            <img style="max-width: 300px;" :id="(() => 'barCode2_'+productInfo.pkid)()"/></td>
        </tr>
        <!--        <tr>-->
        <!--          <td colspan="3" style="text-align: center;font-size: 12px;font-weight: bold;">{{barCodeText}}</td>-->
        <!--        </tr>-->
      </table>
    </div>
    <span slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
      <el-button type="primary" v-print="printOption" @click="print">打印</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import JsBarcode from "jsbarcode";
  import moment from "moment";

  export default {
    data() {
      return {
        dialogVisible: false,
        printType: "",
        printDate: "",
        printPcs: "",
        productInfo: {},
        barCodeText: "",
        printOption: {
          id: "printMaterialBoxLabel2",
          preview: false,
          popTitle: "打印",
          previewPrintBtnLabel: "打印",
          clickMounted() {
          },
        },
      };
    },

    methods: {
      open(productInfo) {
        this.dialogVisible = true;
        this.productInfo = productInfo;
        this.printType=this.productInfo.specification;
        this.printPcs = "1PCS";
        this.printDate = this.productInfo.planStartTime;
        this.barCodeText = moment(new Date()).format("YYYYMM")+"000";

        this.$nextTick(() => {
          document.getElementById("barCode2_" + this.productInfo.pkid).innerHTML = "";
          this.bindBarCode(this.barCodeText, this.productInfo.pkid);
        });
      },
      bindBarCode(row, id) {
        let text = row;
        new JsBarcode(document.getElementById("barCode2_" + id), row, {
          text: text,
          fontSize: 18,
          width: 4,
          height: 20,
          marginTop: 0,
          displayValue: true,
          fontOptions: "bold",
        });
      },
      codeChange() {
        // this.$nextTick(() => {
        document.getElementById("barCode2_" + this.productInfo.pkid).innerHTML = "";
        this.bindBarCode(this.barCodeText, this.productInfo.pkid);
        // });
      },

      print() {
        // this.printLoading = true;
        // document.body.innerHTML = document.getElementById("printMaterialBoxLabel").parentNode.innerHTML;
        // window.print();
        // window.location.reload();
        //
      },
    },
  };
</script>
<style lang="scss" scoped>
.materialCodeModal .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}

.materialCodeModal .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.materialCodeModal .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 39px;
  height: 90%;
}

.materialCodeModal .el-divider--horizontal {
  margin: 10px 0;
}

.materialCodeModal .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}
</style>

<style lang="scss" scoped>
#printMaterialBoxLabel2 {
  width: 76mm;
  height: 36mm;
  margin: 0 auto;
  margin-top: 1.5mm;
  page-break-before: always;
  font-size: 10px;

  table {
    width: 100%;
    height: 100%;

    td {
      border: 0px solid #111;
      //border-bottom: 0;
      //border-right: 0;
      padding: 1mm;
      box-sizing: border-box;
      height: 7mm;
    }

    tr:first-child td:first-child {
      border-bottom: 1px solid #111;
    }

    tr:last-child td {
      border-bottom: 1px solid #111;
    }

    tr td:last-child {
      border-right: 1px solid #111;
    }
  }
}
</style>
